/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccessibleDocument } from '../models/AccessibleDocument';
import type { DirView } from '../models/DirView';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DocumentsService {

    /**
     * Download File which is accessible for User
     * @param id
     * @returns any Successful Response
     * @throws ApiError
     */
    public static reverseProxyDocGetFileGet(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/doc/getFile/',
            query: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get a list of all available Documents - this should be Admins only
     * @param id
     * @param hausverwaltung
     * @returns DirView Successful Response
     * @throws ApiError
     */
    public static hidriveGetFilesDocGetDirContentGet(
        id?: string,
        hausverwaltung: boolean = false,
    ): CancelablePromise<DirView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/doc/getDirContent',
            query: {
                'id': id,
                'hausverwaltung': hausverwaltung,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get a list of all available Documents - User specific
     * @param id
     * @returns DirView Successful Response
     * @throws ApiError
     */
    public static hidriveGetFilesUserDocGetDirContentUserGet(
        id?: string,
    ): CancelablePromise<DirView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/doc/getDirContent_User',
            query: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get a list of all Users and Usergroups that have access
     * @returns AccessibleDocument Successful Response
     * @throws ApiError
     */
    public static getAccessibleDocsDocGetAccessibleDocsGet(): CancelablePromise<Record<string, AccessibleDocument>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/doc/getAccessibleDocs',
        });
    }

    /**
     * Get a list of all available Documents - this should be Admins only
     * @param hausverwaltung
     * @param bauarbeiterExtern
     * @returns any Successful Response
     * @throws ApiError
     */
    public static hidriveGetFilesDocGetFilesGet(
        hausverwaltung: boolean = false,
        bauarbeiterExtern: boolean = false,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/doc/getFiles',
            query: {
                'hausverwaltung': hausverwaltung,
                'bauarbeiterExtern': bauarbeiterExtern,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get a list of all available Documents for User - User specific
     * @returns any Successful Response
     * @throws ApiError
     */
    public static hidriveGetFilesUserDocGetFilesUserGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/doc/getFiles/User',
        });
    }

    /**
     * Update User, die auf Dokument/Ordner zugreifen dürfen
     * @param hidriveId
     * @param type
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateDocumentByIdDocUpdatePost(
        hidriveId: string,
        type?: string,
        requestBody?: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/doc/update',
            query: {
                'hidrive_id': hidriveId,
                'type': type,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Usergroups, die auf Dokument/Ordner zugreifen dürfen
     * @param hidriveId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateSharedUsergroupsDocumentByIdDocUpdateSharedUsergroupsPost(
        hidriveId: string,
        requestBody?: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/doc/update/sharedUsergroups',
            query: {
                'hidrive_id': hidriveId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete all Documents - this should be Admins only and never done
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteDocumentsAllDocDeleteAllGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/doc/deleteAll',
        });
    }

    /**
     * Get all Documents - this should be Admins only
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getDocumentsAllDocGetAllGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/doc/getAll',
        });
    }

    /**
     * Create a new Folder - Hausverwaltung Admins
     * @param name
     * @param parentId
     * @param template
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createFolderDocCreateFolderPost(
        name: string,
        parentId: string,
        template?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/doc/createFolder',
            query: {
                'name': name,
                'parentID': parentId,
                'template': template,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List available folder templates
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listFolderTemplatesDocFolderTemplatesGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/doc/folderTemplates',
        });
    }

    /**
     * Delete a File - Hausverwaltung Admins
     * @param fileid
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteFileDocDeleteFileHausverwaltungPost(
        fileid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/doc/deleteFileHausverwaltung',
            query: {
                'fileid': fileid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete a Folder - Special Admins only
     * @param dirid
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteFolderDocDeleteFolderDelete(
        dirid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/doc/deleteFolder',
            query: {
                'dirid': dirid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Mark a document as read for the current user
     * @param documentHidriveId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static markDocumentAsReadDocMarkAsReadDocumentHidriveIdPost(
        documentHidriveId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/doc/markAsRead/{document_hidrive_id}',
            path: {
                'document_hidrive_id': documentHidriveId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete a document from the database
     * Delete a document from the database when it no longer exists in HiDrive
     * @param documentHidriveId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteDocumentDocDeleteDocumentHidriveIdDelete(
        documentHidriveId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/doc/delete/{document_hidrive_id}',
            path: {
                'document_hidrive_id': documentHidriveId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Move a document to a different folder
     * Move a document (or folder) to a different folder in MinIO.
     *
     * With path-as-identity the object key changes, so we copy+delete in S3 and
     * rewrite the DB document rows to the new key. Shares survive (the M2M tables
     * key on the integer documents.id). The in-memory tree is reconciled by the
     * sync loop; we also update it best-effort for an immediate response.
     * @param documentHidriveId
     * @param fileName
     * @param destinationFolderId
     * @param destinationFolderPath
     * @returns any Successful Response
     * @throws ApiError
     */
    public static moveDocumentDocMovePost(
        documentHidriveId: string,
        fileName: string,
        destinationFolderId: string,
        destinationFolderPath: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/doc/move',
            query: {
                'document_hidrive_id': documentHidriveId,
                'file_name': fileName,
                'destination_folder_id': destinationFolderId,
                'destination_folder_path': destinationFolderPath,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Copy a folder to a different folder
     * Recursively copy a folder in MinIO and preserve document sharing metadata.
     * @param sourceFolderId
     * @param destinationFolderId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static copyFolderDocCopyFolderPost(
        sourceFolderId: string,
        destinationFolderId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/doc/copyFolder',
            query: {
                'source_folder_id': sourceFolderId,
                'destination_folder_id': destinationFolderId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
